import { LOCATION_INITIALIZED } from '@angular/common';
import { Injectable, Injector } from '@angular/core';
import { LogService } from '@core/logging';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TranslateLangService {
  private static readonly DEFAULT_LANGUAGE = 'de-DE';

  constructor(
    private injector: Injector,
    private logService: LogService,
    private translate: TranslateService
  ) {}

  public async load(): Promise<void> {
    try {
      await this.injector.get(LOCATION_INITIALIZED, Promise.resolve(null));

      const defaultLang = TranslateLangService.DEFAULT_LANGUAGE;

      this.translate.setDefaultLang(defaultLang);
      await this.translate.use(defaultLang).toPromise();
    } catch (error) {
      this.logService.error('Failed to initialize language.', error);
    }
  }
}
